import { useEffect } from 'react';

export default function FornecedoresChatbot() {
    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/themes/df-messenger-default.css';
        document.head.appendChild(link);

        const script = document.createElement('script');
        script.src = 'https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/df-messenger.js';
        document.body.appendChild(script);

        return () => {
            if (document.head.contains(link)) document.head.removeChild(link);
            if (document.body.contains(script)) document.body.removeChild(script);
        };
    }, []);

    return (
        <>
            <df-messenger
                location="us-central1"
                project-id="fornecedores-access"
                agent-id="05a6c1d4-752d-43f6-9bc4-c588cede254a"
                language-code="pt-br"
                max-query-length="-1"
            >
                <df-messenger-chat-bubble chat-title="Banco de Fornecedores" />
            </df-messenger>
            <style>{`
                df-messenger {
                    z-index: 999;
                    position: fixed;
                    --df-messenger-font-color: #000;
                    --df-messenger-font-family: Google Sans;
                    --df-messenger-chat-background: #f3f6fc;
                    --df-messenger-message-user-background: #d3e3fd;
                    --df-messenger-message-bot-background: #fff;
                    bottom: 80px;
                    right: 16px;
                }
            `}</style>
        </>
    );
}
